import React from 'react'

import { GetDocumentType } from '../../../utils/GetDocumentType'
import { StyledButtonDownload } from './SlideDocument.styled'
import dateToTimestamp from '../../../utils/dateToTimestamp'

const SlideDocument = (documents, orientation, parentPageNameForGtm) => {
  if (!documents) return null

  const filteredDocuments = documents.filter((file) => {
    if (file.expirationDate) {
      const isDatePassed = Math.sign(
        dateToTimestamp(file.expirationDate) - Date.now()
      )
      if (
        !file.contentfulAsset &&
        !file.cloudinary &&
        !file.url &&
        isDatePassed === -1
      ) {
        return null
      }
    }
    return file
  })
  return filteredDocuments.map((file, index) => {
    const desc = GetDocumentType(file)
    return (
      <StyledButtonDownload
        description={desc}
        document={file}
        key={index}
        name={file.name}
        $orientation={orientation}
        parentPageNameForGtm={parentPageNameForGtm}
      />
    )
  })
}

export default SlideDocument
